import { InputError } from '@foodsby/nutrient'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { loginStart } from '../../redux/modules/user'
import { forgotPasswordRoute } from '../../routes/routes'
import { pushAnalyticsEvent } from '../../util/gtmUtils'
import { pushSnowplow, toSignupProcessSchema } from '../../util/snowplow'
import LoginForm from './LoginForm'

const LoginExtraButtons = () => (
  <div className="row">
    <div className="col-xs-12 center-xs">
      <Link tabIndex="5" to={forgotPasswordRoute.path}>
        Forgot Password?
      </Link>
    </div>
  </div>
)

const LoginPageForm = ({ error, loginStart, path, submitting }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  useEffect(() => {
    pushSnowplow(toSignupProcessSchema('sign_in', 'user_view'))
  }, [])

  useEffect(() => {
    if (error) {
      pushSnowplow(toSignupProcessSchema('sign_in', 'form_submit', 'failure', error.message))
    }
  }, [error])

  return (
    <section>
      <LoginForm
        handleSubmit={creds => {
          loginStart(creds, path)
          pushAnalyticsEvent('Registration Flow', 'Logged In')
        }}
        isPasswordVisible={isPasswordVisible}
        submitting={submitting}
        toggleVisibility={() => setIsPasswordVisible(!isPasswordVisible)}
      />
      <div className="row center-xs">
        <div className="col-xs">
          <InputError>{error ? error.message : ''}</InputError>
        </div>
      </div>
      <LoginExtraButtons />
    </section>
  )
}

const mapStateToProps = state => {
  const { error, submitting } = state.user
  const { address = '' } = state.locationSearch

  return {
    address,
    error,
    submitting,
  }
}

const mapDispatchToProps = {
  loginStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageForm)
